<template>
  <Message
    unstyled
    :class="alertClasses"
    :pt="{
      content: { class: 'w-full flex items-start gap-4 p-4' },
      text: { class: 'w-full' },
    }"
    :closable
  >
    <template #icon>
      <slot name="icon">
        <icon data="@icon/info.svg" width="1.5em" height="1.5em" />
      </slot>
    </template>
    <template #closeicon>
      <slot name="closeicon">
        <p v-if="closeText" class="text-lg">Close</p>
        <CloseIcon v-else></CloseIcon>
      </slot>
    </template>
    <div class="flex flex-col">
      <p v-if="text" class="m-0 font-semibold leading-none" :class="textClass">
        {{ text }}
      </p>
      <p v-if="description" class="text-lg leading-normal" :class="{ 'mt-2': text }">
        {{ description }}
      </p>
      <slot />
    </div>
  </Message>
</template>

<script setup lang="ts">
import { computed } from "vue";
import Message from "primevue/message";
import CloseIcon from "@/components/svg/CloseIcon.vue";

const props = defineProps({
  type: {
    type: String,
    default: "primary",
  },
  text: String,
  textClass: {
    type: String,
    default: "text-xl",
  },
  description: String,
  isOutlined: Boolean,
  closeText: Boolean,
  closable: {
    type: Boolean,
    default: true,
  },
});
const alertClasses = computed(() => `alert-${props.type}${props.isOutlined ? "-outlined" : ""}`);
</script>
